import { render, staticRenderFns } from "./Hand.vue?vue&type=template&id=4e1a07d6&scoped=true"
import script from "./Hand.vue?vue&type=script&lang=js"
export * from "./Hand.vue?vue&type=script&lang=js"
import style0 from "./Hand.vue?vue&type=style&index=0&id=4e1a07d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1a07d6",
  null
  
)

export default component.exports